var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grid is-col-min-15" },
    [
      _c(
        "div",
        { staticClass: "cell is-flex is-flex-direction-column grid mb-0" },
        [
          _c("div", { staticClass: "is-flex-grow-1 is-flex cell" }, [
            _c(
              "article",
              { staticClass: "box is-flex-grow-1" },
              [
                _c("div", { staticClass: "columns is-gapless" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "column" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("div", { staticClass: "is-pulled-right" }, [
                        _c("div", { staticClass: "is-pulled-right" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "button is-small is-success tooltip is-tooltip-bottom",
                              attrs: { "data-tooltip": "Add Remarks" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleRemarkModal()
                                },
                              },
                            },
                            [_vm._m(1), _c("span", [_vm._v("Remarks")])]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.filter.pageIndex,
                      "page-size": _vm.filter.pageSize,
                      "total-rows": _vm.remarkTotalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.filter.sortColumn,
                      "sort-order": _vm.filter.sortOrder,
                      "show-header": false,
                    },
                    on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                  },
                  [
                    _vm._l(_vm.pagedRemarks, function (remark, index) {
                      return _c(
                        "tr",
                        {
                          key: remark.remarkId,
                          on: {
                            click: function ($event) {
                              return _vm.highlightSelected(index, $event)
                            },
                          },
                        },
                        [
                          _c("td", [
                            _c("div", { staticClass: "is-pulled-left ml-1" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.editRemarkRowNumber === -1 ||
                                        _vm.editRemarkRowNumber !== index,
                                      expression:
                                        "editRemarkRowNumber === -1 || editRemarkRowNumber !== index",
                                    },
                                  ],
                                },
                                [_vm._v(_vm._s(remark.remarks))]
                              ),
                              _vm.editRemarkRowNumber === index
                                ? _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editRemarkInnerValue,
                                        expression: "editRemarkInnerValue",
                                      },
                                      {
                                        name: "focus-inserted",
                                        rawName: "v-focus-inserted",
                                      },
                                    ],
                                    staticClass: "textarea",
                                    attrs: { rows: "3" },
                                    domProps: {
                                      value: _vm.editRemarkInnerValue,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.editRemarkInnerValue =
                                          $event.target.value
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]),
                            _c("div", { staticClass: "is-clearfix" }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "is-flex is-align-items-center is-size-7",
                              },
                              [
                                remark.firstName || remark.displayName
                                  ? _c("user-profile-icon", {
                                      staticClass: "pr-1",
                                      attrs: {
                                        "is-text-profile": true,
                                        "first-name": remark.firstName,
                                        "last-name": remark.lastName,
                                        "display-name": remark.displayName,
                                        width: 20,
                                        height: 20,
                                      },
                                    })
                                  : _vm._e(),
                                _c("span", { staticClass: "is-italic pr-1" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatDateTimeLocale(
                                        remark.remarkDateTime,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                remark.isSyncRepX
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "is-rounded is-success tag is-italic",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "mdi mdi-check mdi-14px",
                                        }),
                                        _vm._v(" RepX "),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("td", { staticClass: "is-content-width" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-danger is-small is-inverted",
                                on: {
                                  click: function ($event) {
                                    return _vm.setPinRemarkOrder(remark)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon is-medium" }, [
                                  _c("i", {
                                    staticClass: "mdi mdi-22px",
                                    class: [
                                      remark.pinRemarkOrder !== null
                                        ? "mdi-pin"
                                        : "mdi-pin-outline",
                                    ],
                                  }),
                                ]),
                              ]
                            ),
                            _vm.$user.info.isSupportUser ||
                            _vm.$user.info.isCustomerAdministrator
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button is-primary is-small is-inverted",
                                    on: {
                                      mousedown: function ($event) {
                                        return _vm.editRemark(index, remark)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-medium" },
                                      [
                                        _c("i", {
                                          staticClass: "mdi mdi-24px",
                                          class: [
                                            _vm.editRemarkRowNumber !== index
                                              ? "mdi-lead-pencil"
                                              : "mdi-check",
                                          ],
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.editRemarkRowNumber === index
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button is-danger is-small is-inverted",
                                    on: {
                                      click: function ($event) {
                                        return _vm.cancelEditRemark()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-medium" },
                                      [
                                        _c("i", {
                                          staticClass: "mdi mdi-close mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.$user.info.isSupportUser ||
                            _vm.$user.info.isCustomerAdministrator
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button is-danger is-small is-inverted",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteRemark(
                                          index,
                                          remark.remarkId,
                                          remark.remarkTypeId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-medium" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-delete mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.innerValue.dueInNotes.length !== 0,
                  expression: "innerValue.dueInNotes.length !== 0",
                },
              ],
              staticClass: "cell",
            },
            [
              _c("article", { staticClass: "box" }, [
                _vm._m(2),
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.dueInFilter.pageIndex,
                          "page-size": _vm.dueInFilter.pageSize,
                          "total-rows": _vm.dueInNotesTotalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.dueInFilter.sortColumn,
                          "sort-order": _vm.dueInFilter.sortOrder,
                          "show-header": false,
                        },
                        on: {
                          pageChanged: _vm.onDueInNotePageChange,
                          sort: _vm.sort,
                        },
                      },
                      [
                        _vm._l(_vm.pagedDueInNotes, function (remark, index) {
                          return _c(
                            "tr",
                            {
                              key: remark.remarkId,
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "is-pulled-left ml-1" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.editDueInNoteRowNumber ===
                                                -1 ||
                                              _vm.editDueInNoteRowNumber !==
                                                index,
                                            expression:
                                              "editDueInNoteRowNumber === -1 || editDueInNoteRowNumber !== index",
                                          },
                                        ],
                                      },
                                      [_vm._v(_vm._s(remark.remarks))]
                                    ),
                                    _vm.editDueInNoteRowNumber === index
                                      ? _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.editDueInNoteInnerValue,
                                              expression:
                                                "editDueInNoteInnerValue",
                                            },
                                            {
                                              name: "focus-inserted",
                                              rawName: "v-focus-inserted",
                                            },
                                          ],
                                          staticClass: "textarea",
                                          attrs: { rows: "3" },
                                          domProps: {
                                            value: _vm.editDueInNoteInnerValue,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.editDueInNoteInnerValue =
                                                $event.target.value
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                                _c("div", { staticClass: "is-clearfix" }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "is-flex is-align-items-center is-size-7",
                                  },
                                  [
                                    remark.firstName || remark.displayName
                                      ? _c("user-profile-icon", {
                                          staticClass: "pr-1",
                                          attrs: {
                                            "is-text-profile": true,
                                            "first-name": remark.firstName,
                                            "last-name": remark.lastName,
                                            "display-name": remark.displayName,
                                            width: 20,
                                            height: 20,
                                          },
                                        })
                                      : _vm._e(),
                                    _c("span", { staticClass: "is-italic" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatDateTimeLocale(
                                            remark.remarkDateTime,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm.$user.info.isSupportUser ||
                              _vm.$user.info.isCustomerAdministrator
                                ? _c(
                                    "td",
                                    { staticClass: "is-content-width" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-primary is-small is-inverted",
                                          on: {
                                            click: function ($event) {
                                              return _vm.editDueInNote(
                                                index,
                                                remark
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass: "mdi mdi-24px",
                                                class: [
                                                  _vm.editDueInNoteRowNumber !==
                                                  index
                                                    ? "mdi-lead-pencil"
                                                    : "mdi-check",
                                                ],
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.editDueInNoteRowNumber === index
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "button is-danger is-small is-inverted",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.cancelEditDueInNote()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "icon is-medium",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "mdi mdi-close mdi-24px",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-danger is-small is-inverted",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteRemark(
                                                index,
                                                remark.remarkId,
                                                remark.remarkTypeId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-delete mdi-24px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.innerValue.dueOutNotes.length !== 0,
                  expression: "innerValue.dueOutNotes.length !== 0",
                },
              ],
              staticClass: "cell",
            },
            [
              _c("article", { staticClass: "box" }, [
                _vm._m(3),
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.dueOutFilter.pageIndex,
                          "page-size": _vm.dueOutFilter.pageSize,
                          "total-rows": _vm.dueOutNotesTotalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.dueOutFilter.sortColumn,
                          "sort-order": _vm.dueOutFilter.sortOrder,
                          "show-header": false,
                        },
                        on: {
                          pageChanged: _vm.onDueOutNotePageChange,
                          sort: _vm.sort,
                        },
                      },
                      [
                        _vm._l(_vm.pagedDueOutNotes, function (remark, index) {
                          return _c(
                            "tr",
                            {
                              key: remark.remarkId,
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "is-pulled-left ml-1" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.editDueOutNoteRowNumber ===
                                                -1 ||
                                              _vm.editDueOutNoteRowNumber !==
                                                index,
                                            expression:
                                              "editDueOutNoteRowNumber === -1 || editDueOutNoteRowNumber !== index",
                                          },
                                        ],
                                      },
                                      [_vm._v(_vm._s(remark.remarks))]
                                    ),
                                    _vm.editDueOutNoteRowNumber === index
                                      ? _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.editDueOutNoteInnerValue,
                                              expression:
                                                "editDueOutNoteInnerValue",
                                            },
                                            {
                                              name: "focus-inserted",
                                              rawName: "v-focus-inserted",
                                            },
                                          ],
                                          staticClass: "textarea",
                                          attrs: { rows: "3" },
                                          domProps: {
                                            value: _vm.editDueOutNoteInnerValue,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.editDueOutNoteInnerValue =
                                                $event.target.value
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                                _c("div", { staticClass: "is-clearfix" }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "is-flex is-align-items-center is-size-7",
                                  },
                                  [
                                    remark.firstName || remark.displayName
                                      ? _c("user-profile-icon", {
                                          staticClass: "pr-1",
                                          attrs: {
                                            "is-text-profile": true,
                                            "first-name": remark.firstName,
                                            "last-name": remark.lastName,
                                            "display-name": remark.displayName,
                                            width: 20,
                                            height: 20,
                                          },
                                        })
                                      : _vm._e(),
                                    _c("span", { staticClass: "is-italic" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatDateTimeLocale(
                                            remark.remarkDateTime,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm.$user.info.isSupportUser ||
                              _vm.$user.info.isCustomerAdministrator
                                ? _c(
                                    "td",
                                    { staticClass: "is-content-width" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-primary is-small is-inverted",
                                          on: {
                                            click: function ($event) {
                                              return _vm.editDueOutNote(
                                                index,
                                                remark
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass: "mdi mdi-24px",
                                                class: [
                                                  _vm.editDueOutNoteRowNumber !==
                                                  index
                                                    ? "mdi-lead-pencil"
                                                    : "mdi-check",
                                                ],
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.editDueOutNoteRowNumber === index
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "button is-danger is-small is-inverted",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.cancelEditDueOutNote()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "icon is-medium",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "mdi mdi-close mdi-24px",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-danger is-small is-inverted",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteRemark(
                                                index,
                                                remark.remarkId,
                                                remark.remarkTypeId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-delete mdi-24px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "cell is-flex is-flex-direction-column grid" },
        [
          _c("div", { staticClass: "cell" }, [
            _c("article", { staticClass: "box" }, [
              _c("div", { staticClass: "columns is-gapless" }, [
                _vm._m(4),
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("div", { staticClass: "is-pulled-right" }, [
                      _c("div", { staticClass: "is-pulled-right" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button is-small is-success tooltip is-tooltip-bottom",
                            attrs: { "data-tooltip": "Add Remarks" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleRemarkModal()
                              },
                            },
                          },
                          [_vm._m(5), _c("span", [_vm._v("Remarks")])]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c(
                    "bulma-table",
                    {
                      staticClass:
                        "table is-bordered is-striped is-narrow is-fullwidth",
                      attrs: {
                        columns: _vm.columns,
                        "page-index": _vm.printedFilter.pageIndex,
                        "page-size": _vm.printedFilter.pageSize,
                        "total-rows": _vm.printedRemarkTotalRows,
                        "is-loading": _vm.isTableLoading,
                        "sort-column": _vm.printedFilter.sortColumn,
                        "sort-order": _vm.printedFilter.sortOrder,
                        "show-header": false,
                      },
                      on: {
                        pageChanged: _vm.onPrintedRemarksPageChange,
                        sort: _vm.sort,
                      },
                    },
                    [
                      _vm._l(_vm.pagedPrintedRemarks, function (remark, index) {
                        return _c("tr", { key: remark.remarkId }, [
                          _c("td", { staticClass: "is-remark" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.editPrintedRemarkRowNumber === -1 ||
                                      _vm.editPrintedRemarkRowNumber !== index,
                                    expression:
                                      "editPrintedRemarkRowNumber === -1 || editPrintedRemarkRowNumber !== index",
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(remark.remarks))]
                            ),
                            _vm.editPrintedRemarkRowNumber === index
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.editPrintedRemarkInnerValue,
                                      expression: "editPrintedRemarkInnerValue",
                                    },
                                    {
                                      name: "focus-inserted",
                                      rawName: "v-focus-inserted",
                                    },
                                  ],
                                  staticClass: "textarea",
                                  attrs: { rows: "3" },
                                  domProps: {
                                    value: _vm.editPrintedRemarkInnerValue,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.editPrintedRemarkInnerValue =
                                        $event.target.value
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "is-flex is-align-items-center is-size-7",
                              },
                              [
                                remark.firstName || remark.displayName
                                  ? _c("user-profile-icon", {
                                      staticClass: "pr-1",
                                      attrs: {
                                        "is-text-profile": true,
                                        "first-name": remark.firstName,
                                        "last-name": remark.lastName,
                                        "display-name": remark.displayName,
                                        width: 20,
                                        height: 20,
                                      },
                                    })
                                  : _vm._e(),
                                _c("span", { staticClass: "is-italic" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatDateTimeLocale(
                                        remark.remarkDateTime,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _vm.$user.info.isSupportUser ||
                          _vm.$user.info.isCustomerAdministrator
                            ? _c(
                                "td",
                                {
                                  staticClass:
                                    "has-text-centered is-content-width has-vertical-middle",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-primary is-small is-inverted",
                                      on: {
                                        click: function ($event) {
                                          return _vm.editPrintedRemark(
                                            index,
                                            remark
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "icon is-medium" },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-24px",
                                            class: [
                                              _vm.editPrintedRemarkRowNumber !==
                                              index
                                                ? "mdi-lead-pencil"
                                                : "mdi-check",
                                            ],
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm.editPrintedRemarkRowNumber === index
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-danger is-small is-inverted",
                                          on: {
                                            click: function ($event) {
                                              return _vm.cancelEditPrintedRemark()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-close mdi-24px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-danger is-small is-inverted",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteRemark(
                                            index,
                                            remark.remarkId,
                                            remark.remarkTypeId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "icon is-medium" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-delete mdi-24px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      }),
                      _c("template", { slot: "empty" }, [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered",
                            },
                            [
                              _c("span", { attrs: { icon: "icon is-large" } }, [
                                _c("i", {
                                  staticClass: "mdi mdi-48px mdi-emoticon-sad",
                                }),
                              ]),
                              _c("p", [_vm._v("Nothing")]),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm.showJobNoteRemarks
            ? _c("div", { staticClass: "cell" }, [
                _c("article", { staticClass: "box" }, [
                  _c("div", { staticClass: "columns is-gapless" }, [
                    _vm._m(6),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "is-pulled-right" }, [
                          _c("div", { staticClass: "is-pulled-right" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button is-small is-success tooltip",
                                attrs: { "data-tooltip": "Add Remarks" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleRemarkModal()
                                  },
                                },
                              },
                              [_vm._m(7), _c("span", [_vm._v("Remarks")])]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c(
                        "bulma-table",
                        {
                          staticClass:
                            "table is-bordered is-striped is-narrow is-fullwidth",
                          attrs: {
                            columns: _vm.columns,
                            "page-index": _vm.jobFilter.pageIndex,
                            "page-size": _vm.jobFilter.pageSize,
                            "total-rows": _vm.jobRemarkTotalRows,
                            "is-loading": _vm.isTableLoading,
                            "sort-column": _vm.jobFilter.sortColumn,
                            "sort-order": _vm.jobFilter.sortOrder,
                            "show-header": false,
                          },
                          on: {
                            pageChanged: _vm.onJobNoteRemarksPageChange,
                            sort: _vm.sort,
                          },
                        },
                        [
                          _vm._l(
                            _vm.pagedJobNoteRemarks,
                            function (remark, index) {
                              return _c("tr", { key: remark.remarkId }, [
                                _c("td", { staticClass: "is-remark" }, [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.editJobNoteRemarkRowNumber ===
                                              -1 ||
                                            _vm.editJobNoteRemarkRowNumber !==
                                              index,
                                          expression:
                                            "editJobNoteRemarkRowNumber === -1 || editJobNoteRemarkRowNumber !== index",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(remark.remarks))]
                                  ),
                                  _vm.editJobNoteRemarkRowNumber === index
                                    ? _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.editJobNoteRemarkInnerValue,
                                            expression:
                                              "editJobNoteRemarkInnerValue",
                                          },
                                          {
                                            name: "focus-inserted",
                                            rawName: "v-focus-inserted",
                                          },
                                        ],
                                        staticClass: "textarea",
                                        attrs: { rows: "3" },
                                        domProps: {
                                          value:
                                            _vm.editJobNoteRemarkInnerValue,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.editJobNoteRemarkInnerValue =
                                              $event.target.value
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "is-flex is-align-items-center is-size-7",
                                    },
                                    [
                                      remark.firstName || remark.displayName
                                        ? _c("user-profile-icon", {
                                            staticClass: "pr-1",
                                            attrs: {
                                              "is-text-profile": true,
                                              "first-name": remark.firstName,
                                              "last-name": remark.lastName,
                                              "display-name":
                                                remark.displayName,
                                              width: 20,
                                              height: 20,
                                            },
                                          })
                                        : _vm._e(),
                                      _c("span", { staticClass: "is-italic" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$filters.formatDateTimeLocale(
                                              remark.remarkDateTime,
                                              _vm.$userInfo.locale
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm.$user.info.isSupportUser ||
                                _vm.$user.info.isCustomerAdministrator
                                  ? _c(
                                      "td",
                                      {
                                        staticClass:
                                          "has-text-centered is-content-width has-vertical-middle",
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-primary is-small is-inverted",
                                            on: {
                                              click: function ($event) {
                                                return _vm.editJobNoteRemark(
                                                  index,
                                                  remark
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass: "mdi mdi-24px",
                                                  class: [
                                                    _vm.editJobNoteRemarkRowNumber !==
                                                    index
                                                      ? "mdi-lead-pencil"
                                                      : "mdi-check",
                                                  ],
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.editJobNoteRemarkRowNumber === index
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "button is-danger is-small is-inverted",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.cancelEditJobNoteRemark()
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "icon is-medium",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "mdi mdi-close mdi-24px",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-danger is-small is-inverted",
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteRemark(
                                                  index,
                                                  remark.remarkId,
                                                  remark.remarkTypeId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-delete mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            }
                          ),
                          _c("template", { slot: "empty" }, [
                            _c("section", { staticClass: "section" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "content has-text-grey has-text-centered",
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { icon: "icon is-large" } },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-48px mdi-emoticon-sad",
                                      }),
                                    ]
                                  ),
                                  _c("p", [_vm._v("Nothing")]),
                                ]
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "cell" }, [
            _c(
              "article",
              { staticClass: "box" },
              [
                _c("div", { staticClass: "columns is-gapless" }, [
                  _vm._m(8),
                  _c("div", { staticClass: "column" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("div", { staticClass: "control is-pulled-right" }, [
                        _c("div", { staticClass: "is-pulled-right" }, [
                          _c("div", { staticClass: "select" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.otherRemarksIdFilter,
                                    expression: "otherRemarksIdFilter",
                                  },
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.otherRemarksIdFilter = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { domProps: { value: 0 } }, [
                                  _vm._v("All"),
                                ]),
                                _vm._l(
                                  _vm.formattedRemarkTypes,
                                  function (remark) {
                                    return _c(
                                      "option",
                                      {
                                        key: remark.value,
                                        domProps: { value: remark.value },
                                      },
                                      [_vm._v(_vm._s(remark.label))]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.otherFilter.pageIndex,
                      "page-size": _vm.otherFilter.pageSize,
                      "total-rows": _vm.otherRemarkTotalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.otherFilter.sortColumn,
                      "sort-order": _vm.otherFilter.sortOrder,
                      "show-header": false,
                    },
                    on: {
                      pageChanged: _vm.onOtherRemarksPageChange,
                      sort: _vm.sort,
                    },
                  },
                  [
                    _vm._l(_vm.pagedOtherRemarks, function (remark, index) {
                      return _c("tr", { key: remark.remarkId }, [
                        _c("td", { staticClass: "is-remark" }, [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                remark.remarks.replaceAll("\n", "<br>")
                              ),
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-align-items-center is-size-7",
                            },
                            [
                              _c("span", { staticClass: "is-italic" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimeLocale(
                                      remark.remarkDateTime,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm.$user.info.isSupportUser ||
                        _vm.$user.info.isCustomerAdministrator
                          ? _c(
                              "td",
                              {
                                staticClass:
                                  "has-text-centered is-content-width has-vertical-middle",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button is-danger is-small is-inverted",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteRemark(
                                          index,
                                          remark.remarkId,
                                          remark.remarkTypeId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-medium" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-delete mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    }),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c("quote-incident-notes", {
            attrs: {
              value: _vm.innerValue.incidentNotes,
              "is-saving": _vm.isIncidentNotesSaving,
            },
            on: {
              "text-change": _vm.onIncidentNotesTextChange,
              "date-change": _vm.onIncidentNotesDateChange,
              "notes-blur": _vm.onIncidentNotesSave,
              "date-save": _vm.onIncidentNotesSave,
            },
          }),
        ],
        1
      ),
      _vm.value && _vm.isRemarkModalActive
        ? _c(
            "remark-modal",
            {
              attrs: {
                "show-remark": true,
                "show-printed-remark": true,
                "show-job-note-remark": true,
                "show-recurring-remark": true,
                active: _vm.isRemarkModalActive,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isRemarkModalActive = $event
                },
                add: _vm.addRemarks,
                cancel: function ($event) {
                  return _vm.toggleRemarkModal()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Add Quote Remarks"),
              ]),
              !!_vm.value.repx
                ? _c(
                    "div",
                    {
                      staticClass: "is-flex ml-6",
                      attrs: { slot: "remark-last-postfix" },
                      slot: "remark-last-postfix",
                    },
                    [
                      _c("bulma-checkbox", {
                        model: {
                          value: _vm.value.isSyncRepX,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "isSyncRepX", $$v)
                          },
                          expression: "value.isSyncRepX",
                        },
                      }),
                      _c("div", [_c("small", [_vm._v("Sync to RepX")])]),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Remarks")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-gapless" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Due In Notes")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-gapless" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Due Out Notes")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Printed Remarks")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Job Remarks")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Other Remarks")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }